import styled from 'styled-components';

export interface Props {}

const FogMapLayer = styled.div<Props>`
	background-color: ${(props) => props.theme.colors.fog};
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
`;

export default FogMapLayer;
